import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ConfortLogo } from '../media/confortLogo';
import { SusLogo } from '../media/susLogo';
import { VendorLogo } from '../media/vendor';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Vision() {
  const { texts, isRTL, currentLanguage } = useLanguage();
  const [visionContent, setVisionContent] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    async function fetchVisionContent() {
      try {
        const response = await fetch('/api/vision');
        if (!response.ok) {
          throw new Error('Failed to fetch vision content');
        }
        const data = await response.json();
        console.log("VISION:", data);

        // Extract the actual image URL if it contains HTML markup
        const processedData = {
          ...data.vision,
          imageUrl: data.vision.imageUrl.includes('<a href')
            ? data.vision.imageUrl.match(/src='([^']+)'/)[1]  // Extract URL from src attribute
            : data.vision.imageUrl
        };

        setVisionContent(processedData);
      } catch (error) {
        console.error('Error fetching vision:', error);
      }
    }

    fetchVisionContent();
  }, []);

  if (!visionContent) {
    return null; // or a loading state
  }

  return (
    // Vision Section
    <section id="vision-section" className="bg-white py-[5vh] w-full">
      <div className="w-full px-[4%] sm:px-[5%]">
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-[2rem] w-full ${isRTL ? 'md:grid-flow-col md:grid-cols-2 md:grid-rows-1' : ''}`}>
          {/* Image Container */}
          <div 
            className={`w-full ${isRTL ? 'md:order-2' : 'md:order-1'} transition-all duration-300 ease-in-out rounded-lg overflow-hidden`}
            data-aos="fade-right"
          >
            <img 
              src={visionContent.imageUrl}
              alt={visionContent.imageAlt?.[currentLanguage] || texts.vision.imageAlt}
              className="rounded-lg w-full h-auto object-cover transition-transform duration-300 ease-in-out hover:scale-105"
            />
          </div>

          {/* Text and Icons Container */}
          <div 
            className={`${isRTL ? 'md:order-1 text-right' : 'md:order-2 text-left'} md:mt-[5vh]`}
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <h2 
              className="text-[2rem] sm:text-[2.5rem] md:text-[2rem] font-bold text-black transition-all duration-300 ease-in-out hover:text-[#63A7FB]"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              {visionContent.title[currentLanguage]}
            </h2>
            <p 
              className="mt-[1rem] text-black text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] transition-all duration-300 ease-in-out"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              {visionContent.paragraph1[currentLanguage]}
            </p>
            <p 
              className="mt-[1rem] text-black text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] transition-all duration-300 ease-in-out"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              {visionContent.paragraph2[currentLanguage]}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
